<div class="wrap">
  <header>
    <img src="https://pub-blob.s3.ap-southeast-1.amazonaws.com/public/nitto_warranty_header.webp" alt="" style="width: 100%" />
  </header>
  <div>
    <p class="mb-0">สงวนสิทธิ์ให้ผู้ซื้อเป็นผู้กรอกข้อมูลเท่านั้น</p>
    <p class="m-0 font-14">1. ลูกค้าจะได้รับสิทธิ์นี้เมื่อซื้อยางจำนวน 4 เส้นต่อรถ 1 คัน ต่อ 1 ใบเสร็จ</p>
    <p class="m-0 font-14">2. ลูกค้าจะต้องให้ข้อมูลวันที่ใบเสร็จ ทะเบียนรถ ขนาดและรุ่นยาง ครบถ้วน</p>
    <p class="m-0 font-14">3. ระยะการรับประกัน 60 วัน นับจากวันที่ในใบเสร็จรับเงิน</p>
    <p class="m-0 font-14">4. หากข้อมูลไม่ถูกต้อง และ/หรือ ไม่ครบถ้วน ทางบริษัทฯ ขอสงวนสิทธิ์ ในการยกเลิกสิทธิ์การรับประกันยาง 60 วัน</p>
    <p class="m-0 font-14">5. ลูกค้าติดต่อการเคลมประกัน ณ ร้านที่ท่านซื้อสินค้า</p>
    <div class="center">
      <button class="underline-text" type="button" mat-button (click)="openDialogPolicy()">
        นโยบายการจัดเก็บ ใช้ เปิดเผย และจัดการข้อมูลส่วนบุคคล
      </button>
    </div>
    <h1>ข้อมูลส่วนตัว</h1>
    <form>
      <fieldset>
        <label for="">ชื่อ :</label>
        <mat-form-field class="example-full-width" appearance="outline">
          <input
            id="firstName"
            name="firstName"
            [(ngModel)]="form.firstName"
            [formControl]="firstNameFormcontrol"
            placeholder="First Name"
            matInput
          />
          @if (firstNameFormcontrol.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>ชื่อ</strong>
          </mat-error>
          }
        </mat-form-field>
        <label for="Listname">นามสกุล :</label>
        <mat-form-field class="example-full-width" appearance="outline">
          <input
            id="lastName"
            name="lastName"
            [(ngModel)]="form.lastName"
            [formControl]="lastNameFormcontrol"
            placeholder="Last Name"
            matInput
          />
          @if (lastNameFormcontrol.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>นามสกุล</strong>
          </mat-error>
          }
        </mat-form-field>
        <div class="flex-al-center">
          <label for="gender">เพศ :</label>
          <mat-radio-group
            id="gender"
            name="gender"
            [(ngModel)]="form.gender"
            [formControl]="genderFormControl"
            aria-label="Select an option"
          >
            <div>
              <mat-radio-button value="ชาย">ชาย</mat-radio-button>
              <mat-radio-button value="หญิง">หญิง</mat-radio-button>
              <mat-radio-button value="นิติบุคคล">นิติบุคคล</mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
        <label for="Email">อีเมล :</label>
        <mat-form-field class="example-full-width" appearance="outline">
          <input
            id="email"
            name="email"
            [(ngModel)]="form.email"
            type="email"
            matInput
            [formControl]="emailFormControl"
            placeholder="E mail"
            (keypress)="allowEnglishAndSpecialChars($event)"
          />
          <!-- @if (emailFormControl.hasError('email') &&
            !emailFormControl.hasError('required')) {
            <mat-error>กรุณากรอกอีเมลที่ถูกต้อง</mat-error>
            } @if (emailFormControl.hasError('required')) {
            <mat-error>กรุณากรอก<strong>อีเมล</strong></mat-error>
            } //-->
        </mat-form-field>
        <label for="PhoneNumber">หมายเลขโทรศัพท์มือถือของผู้ซื้อ :</label>
        <mat-form-field class="example-full-width" appearance="outline">
          <input
            id="tel"
            name="tel"
            [(ngModel)]="form.tel"
            type="text"
            min="0"
            (keypress)="allowOnlyNumbers($event)"
            matInput
            placeholder="Mobile Phone"
            [formControl]="telFormControl"
            maxlength="10"
          />
          @if (telFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>หมายเลขโทรศัพท์</strong>
          </mat-error>
          } @else if (telFormControl.hasError('pattern') && telFormControl.touched) {
          <mat-error>
            กรุณากรอก
            <strong>หมายเลขโทรศัพท์ให้ถูกต้อง</strong>
          </mat-error>
          }
        </mat-form-field>

        <label for="CarNumber">รายละเอียด ของเลขทะเบียนรถยนต์ :</label>

        <!-- @if(!redPlate){ -->
        <mat-form-field class="example-full-width" appearance="outline">
          <input
            id="carNumber"
            name="carNumber"
            [(ngModel)]="form.carNumber"
            type=""
            matInput
            [formControl]="carNumberFormControl"
            placeholder="Car number (ตัวอย่าง: กก1234)"
          />
          @if (carNumberFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>เลขทะเบียนรถยนต์</strong>
          </mat-error>
          } @if (!carNumberFormControl.valid && carNumberFormControl.value) {
          <mat-error>
            กรุณากรอก
            <strong>เลขทะเบียนรถยนต์ให้ถูกต้อง</strong>
          </mat-error>
          }
        </mat-form-field>
        <label for="province">รายละเอียด จังหวัดเลขทะเบียนรถยนต์ :</label>
        <!-- <mat-form-field>
          <mat-label>กรุณาเลือกจังหวัดให้ตรงกับเลขทะเบียนรถยนต์</mat-label>
          <mat-select class="custom-select" id="province" name="province" [(ngModel)]="form.province"
            placeholder="จังหวัดเลขทะเบียนรถยนต์" [formControl]="provinceFormControl">
            @for (province of provinces; track province) {
            <mat-option [value]="province.name_th">
              {{ province.name_th }}
            </mat-option>
            }
          </mat-select>
          @if (provinceFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>จังหวัดเลขทะเบียนรถยนต์</strong>
          </mat-error>
          }
        </mat-form-field> -->
        <mat-form-field>
          <mat-label>กรุณาเลือกจังหวัดให้ตรงกับเลขทะเบียนรถยนต์</mat-label>
          <input
            id="province"
            name="province"
            [(ngModel)]="form.province"
            type="text"
            placeholder="จังหวัดเลขทะเบียนรถยนต์"
            aria-label="Number"
            matInput
            [formControl]="provinceFormControl"
            [matAutocomplete]="auto"
            (click)="onClickFilterProvinceFormControl()"
          />
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            @for (option of filteredOptions | async; track option) {
            <mat-option [value]="option.name_th">
              {{ option.name_th }}
            </mat-option>
            }
          </mat-autocomplete>
          @if (provinceFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>จังหวัดเลขทะเบียนรถยนต์</strong>
          </mat-error>
          }
        </mat-form-field>
        <!-- } -->

        <mat-checkbox
          id="newCar"
          name="newCar"
          [(ngModel)]="form.newCar"
          type=""
          matInput
          class="example-margin"
          (change)="changeRedPlate($event.checked)"
        >
          <span class="txt-red-newCar">รถยนต์ของท่านใช้ป้ายแดง</span>
        </mat-checkbox>

        @if(redPlate){
        <div>
          <label for="BandCar">กรุณากรอกรายละเอียดเกี่ยวกับรถยนต์ของท่าน</label>
          <mat-form-field class="example-full-width" appearance="outline">
            <input
              id="bandCar"
              name="bandCar"
              [(ngModel)]="form.bandCar"
              matInput
              [formControl]="bandCarFormControl"
              placeholder="ยี่ห้อรถยนต์ (ตัวอย่าง: Honda,Mazda,Toyota)"
            />
            @if (bandCarFormControl.hasError('required')) {
            <mat-error>
              กรุณากรอก
              <strong>ยี่ห้อรถยนต์</strong>
            </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="outline">
            <input
              id="modelCar"
              name="modelCar"
              [(ngModel)]="form.modelCar"
              matInput
              [formControl]="modelCarFormControl"
              placeholder="รุ่นรถยนต์ (ตัวอย่าง: Civic,Accord,Yaris)"
            />
            @if (modelCarFormControl.hasError('required')) {
            <mat-error>
              กรุณากรอก
              <strong>รุ่นรถยนต์</strong>
            </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="outline">
            <input
              id="colorCar"
              name="colorCar"
              [(ngModel)]="form.colorCar"
              matInput
              [formControl]="colorCarFormControl"
              placeholder="สีรถยนต์ (ตัวอย่าง: ขาว,ดำ,แดง)"
            />
            @if (colorCarFormControl.hasError('required')) {
            <mat-error>
              กรุณากรอก
              <strong>สีรถยนต์</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>

        }

        <h2>รายละเอียด เกี่ยวกับการซื้อยาง</h2>
        <div>
          <!-- <label for="BandTyre">ยี่ห้อยางรถยนต์ :</label>
            <ul>
              <mat-radio-group class="col-2" id="bandTyre" name="bandTyre" [(ngModel)]="form.bandTyre"
                [formControl]="bandTyreFormControl" aria-label="Select an option">
                <mat-radio-button value="Toyo">Toyo</mat-radio-button>
                <mat-radio-button value="Nitto">Nitto</mat-radio-button>
                <mat-radio-button value="Nankang">Nankang</mat-radio-button>
              </mat-radio-group>
            </ul> -->
        </div>
        <label for="DateTyre">วัน เดือน ปี ที่ทำการติดตั้ง :</label>
        <mat-form-field>
          <mat-label>Choose a date</mat-label>
          <input
            id="dateTyre"
            name="dateTyre"
            [(ngModel)]="form.dateTyre"
            matInput
            [matDatepicker]="picker"
            [formControl]="dateTyre"
            [max]="today"
            readonly
          />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #picker></mat-datepicker>
          @if (dateTyre.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>วัน เดือน ปี ที่ทำการติดตั้ง</strong>
          </mat-error>
          }
        </mat-form-field>
        <label for="Loaction Store">ศูนย์บริการที่ทำการติดตั้ง :</label>
        <mat-form-field>
          <mat-label>กรุณาเลือกจังหวัดศูนย์บริการ</mat-label>
          <input
            id="provinceMain"
            name="provinceMain"
            [(ngModel)]="form.provinceMain"
            type="text"
            placeholder="จังหวัดศูนย์บริการ"
            aria-label="Number"
            matInput
            [formControl]="provinceStoreMainFormControl"
            [matAutocomplete]="autoProvinceStoreMain"
            (click)="onClickFilterProvinceStoreMainFormControl()"
          />
          <mat-autocomplete
            autoActiveFirstOption
            #autoProvinceStoreMain="matAutocomplete"
            (optionSelected)="onSelectProvinceStoreMain($event)"
          >
            @for (option of filteredProvinceStoreMainOptions | async; track option) {
            <mat-option [value]="option.name_th">
              {{ option.name_th }}
            </mat-option>
            }
          </mat-autocomplete>
          @if (provinceStoreMainFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>เลือกจังหวัดศูนย์บริการ</strong>
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>กรุณาเลือกศูนย์บริการที่ทำการติดตั้ง</mat-label>
          <input
            id="locationStore"
            name="locationStore"
            [(ngModel)]="form.locationStore"
            type="text"
            placeholder="ศูนย์บริการที่ทำการติดตั้ง"
            aria-label="Number"
            matInput
            [formControl]="locationStoreFormControl"
            [matAutocomplete]="autoLocationStore"
            (click)="onClickFilterLocationStoreFormControl()"
          />
          <mat-autocomplete autoActiveFirstOption #autoLocationStore="matAutocomplete">
            <!-- @for (centerService of filterFranchiseOptions; track centerService) { -->
            @for (centerService of filterLocationStoreOptions | async; track centerService) {
            <mat-option [value]="centerService.name">
              {{ centerService.name }}
            </mat-option>
            }
          </mat-autocomplete>
          @if (locationStoreFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>กรุณาเลือกศูนย์บริการที่ทำการติดตั้ง</strong>
          </mat-error>
          }
        </mat-form-field>

        <!-- 
        <mat-form-field>
          <mat-label>กรุณาเลือกศูนย์บริการที่ทำการติดตั้ง</mat-label>
          <mat-select id="locationStore" name="locationStore" [formControl]="locationStoreFormControl"
            [(ngModel)]="form.locationStore" required>
            @for (centerService of centerServices; track centerService) {
            <mat-option [value]="centerService.name">
              {{ centerService.name }}
            </mat-option>
            }
          </mat-select>
          @if (locationStoreFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>กรุณาเลือกศูนย์บริการที่ทำการติดตั้ง</strong>
          </mat-error>
          }
        </mat-form-field> -->

        <mat-checkbox
          id="storeList"
          name="storeList"
          class="example-margin"
          (change)="changeService($event.checked)"
          [(ngModel)]="form.storeList"
        >
          ศูนย์บริการของท่านไม่อยู่ในลิสต์รายชื่อ
        </mat-checkbox>

        @if(showService){

        <div>
          <label for="Band">กรุณากรอกรายละเอียดศูนย์บริการของท่าน</label>
        </div>
        <mat-form-field class="example-full-width" appearance="outline">
          <input
            id="bandStore"
            name="bandStore"
            [(ngModel)]="form.bandStore"
            matInput
            [formControl]="bandStoreFormControl"
            placeholder="ชื่อร้าน"
          />
          @if (bandStoreFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>ชื่อร้าน</strong>
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline">
          <input
            id="addressStore"
            name="addressStore"
            [(ngModel)]="form.addressStore"
            matInput
            [formControl]="addressStoreFormControl"
            placeholder="ที่อยู่ร้าน"
          />
          @if (addressStoreFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>ที่อยู่ร้าน</strong>
          </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>กรุณาเลือกจังหวัดศูนย์บริการ</mat-label>
          <input
            id="provinceCar"
            name="provinceCar"
            [(ngModel)]="form.provinceCar"
            type="text"
            placeholder="จังหวัดศูนย์บริการ"
            aria-label="Number"
            matInput
            [formControl]="provinceStoreFormControl"
            [matAutocomplete]="autoProvinceStore"
            (click)="onClickFilterProvinceStoreFormControl()"
          />
          <mat-autocomplete autoActiveFirstOption #autoProvinceStore="matAutocomplete">
            @for (option of filteredProvinceStoreOptions | async; track option) {
            <mat-option [value]="option.name_th">
              {{ option.name_th }}
            </mat-option>
            }
          </mat-autocomplete>
          @if (provinceStoreFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>เลือกจังหวัดศูนย์บริการ</strong>
          </mat-error>
          }
        </mat-form-field>
        <!-- <mat-form-field>
          <mat-label>กรุณาเลือกจังหวัดศูนย์บริการ</mat-label>
          <mat-select id="provinceCar" name="provinceCar" [formControl]="provinceStoreFormControl"
            [(ngModel)]="form.provinceCar" required>
            @for (province of provinces; track province) {
            <mat-option [value]="province.name_th">
              {{ province.name_th }}
            </mat-option>
            }
          </mat-select>
          @if (provinceStoreFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>กรุณาเลือกจังหวัดศูนย์บริการ</strong>
          </mat-error>
          }
        </mat-form-field> -->
        <label for="PostalCar">รหัสไปรษณีย์</label>
        <mat-form-field class="example-full-width" appearance="outline">
          <input
            id="PostalCar"
            name="PostalCar"
            [(ngModel)]="form.PostalCar"
            matInput
            matInput
            #postalCode
            maxlength="5"
            [formControl]="postalCarFormControl"
            (keypress)="allowOnlyNumbers($event)"
            placeholder="รหัสไปรษณีย์"
          />
          @if (postalCarFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>รหัสไปรษณีย์</strong>
          </mat-error>
          }
        </mat-form-field>
        <!--       
        <mat-form-field>
          <mat-label>ชื่อร้านตัวแทนจำหน่ายอย่างเป็นทางการ</mat-label>
          <input id="franchiseCar" name="franchiseCar" [(ngModel)]="form.franchiseCar" type="text"
            placeholder="ชื่อร้านตัวแทนจำหน่ายอย่างเป็นทางการ" aria-label="Number" matInput
            [formControl]="franchiseCarFormControl" [matAutocomplete]="autoFranchise">
          <mat-autocomplete autoActiveFirstOption #autoFranchise="matAutocomplete">
            @for (centerService of filterFranchiseOptions | async; track centerService) {
            <mat-option [value]="centerService.name">
              {{ centerService.name }}
            </mat-option>
            }

          </mat-autocomplete>
          @if (provinceStoreFormControl.hasError('required')) {
          <mat-error>
            กรุณากรอก
            <strong>ชื่อร้านตัวแทนจำหน่ายอย่างเป็นทางการ</strong>
          </mat-error>
          }
        </mat-form-field> -->
        }

        <div>
          <label for="rating">ท่านให้คะแนนในการเข้ารับบริการครั้งนี้เท่าใด :</label>
        </div>
        <div class="star-container" matTooltip="{{ hoverRating }}" matTooltipPosition="above">
          <star-rating
            [numOfStars]="5"
            [starType]="'svg'"
            [rating]="currentRating"
            [size]="'large'"
            [hoverEnabled]="true"
            labelPosition="left"
            id="1"
            [staticColor]="'ok'"
            (starClickChange)="onClick($event)"
            (ratingChange)="onRatingChange($event)"
            (hoverRatingChange)="onHoverRatingChange($event)"
          ></star-rating>
        </div>
        <div>
          <label for="file">แนบรูปใบเสร็จ :</label>
          <p class="fileImg">ขนาดไฟล์ไม่เกิน 10MB</p>
        </div>

        <input type="file" (change)="onFileChange($event)" style="margin-top: 1rem" accept=".pdf,.jpg,.jpeg" />
        @if (imgFail && !successFile) {
        <p id="imgFail" style="color: red">อัพโหลดไม่สำเร็จ กรุณาอัพโหลดใหม่</p>
        } @if(!imgFail){ @if (!haveImg && !successFile) {
        <p id="haveImg" style="color: red">กรุณาอัพโหลดรูป</p>
        } } @if(urlImg){ @if (successFile) {
        <p id="successFile" style="color: rgb(33, 143, 6)">อัพโหลดไฟล์สำเร็จ</p>
        } } @else if(!urlImg){ @if (successFile) {
        <p id="successFile" style="color: rgb(233, 191, 7)">กำลังโหลดรูปภาพ</p>
        } } @if (!imgFail && urlImg && !pdfFile) {
        <img [src]="urlImg" alt="Uploaded Image" style="width: 100%" />
        }

        <!-- <button (click)="uploadFile()">Upload</button> -->
        <!-- <div *ngIf="fileInfo">
            <p>File uploaded successfully!</p>
            <p>File URL: <a [href]="fileInfo.url" target="_blank">{{ fileInfo.url }}</a></p>
          </div> -->
        <div class="Ads" style="margin-top: 2rem">
          <label for="Ads" style="color: black">ท่านรู้จักยาง NITTO จากช่องทางใด (เลือกได้มากกว่า 1 ข้อ)</label>
        </div>

        <ul>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['google']" name="google">Google / กูเกิ้ล</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['twitter']" name="twitter">Twitter</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['billboard']" name="billboard">Billboard</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['facebook']" name="facebook">Facebook</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['youtube']" name="youtube">YOUTUBE</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['radio']" name="radio">สื่อวิทยุ</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['instagram']" name="instagram">Instagram</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['friend']" name="friend">เพื่อนแนะนำ</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['printMedia']" name="printMedia">สื่อสิ่งพิมพ์</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['tiktok']" name="tiktok">TikTok</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['store']" name="store">ร้านค้าแนะนำ</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['tv']" name="tv">รายการ TV</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannelsDidyouknow['line']" name="line">LINE</mat-checkbox>
        </ul>
        <label for="AdsChanel" style="color: black">สื่อช่องทางไหนที่ท่านรับชม? (เลือกได้มากกว่า 1 ข้อ)</label>
        <ul>
          <mat-checkbox [(ngModel)]="selectedChannels['google']" name="google">Google / กูเกิ้ล</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['twitter']" name="twitter">Twitter</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['radio']" name="radio">สื่อวิทยุ</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['facebook']" name="facebook">Facebook</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['youtube']" name="youtube">YOUTUBE</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['printMedia']" name="printMedia">สื่อสิ่งพิมพ์</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['instagram']" name="instagram">Instagram</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['line']" name="line">LINE</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['tiktok']" name="tiktok">TikTok</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['billboard']" name="billboard">Billboard</mat-checkbox>
          <mat-checkbox [(ngModel)]="selectedChannels['tv']" name="tv">รายการ TV</mat-checkbox>
        </ul>
        <div class="space-be">
          <mat-radio-group
            id="agreementAccept"
            name="agreementAccept"
            aria-label="Select an option"
            [formControl]="agreementAcceptFormControl"
            style="display: flex; justify-content: center"
          >
            <mat-radio-button value="1">ข้าพเจ้ายอมรับในเงื่อนไขการรับประกัน</mat-radio-button>
          </mat-radio-group>
          <!-- <mat-radio-button value="1" (mousedown)="openDialog('confirm')">ข้าพเจ้ายอมรับในเงื่อนไขการรับประกัน</mat-radio-button>
          </mat-radio-group> -->
          <!-- <mat-checkbox [(ngModel)]="form.agreementAccept" (change)="changeAgreementAccept($event.checked)">ข้าพเจ้ายอมรับในเงื่อนไขการรับประกัน </mat-checkbox> -->
          <button class="underline-text" type="button" mat-button (click)="openDialog('view')">เงื่อนไขการรับประกัน</button>
        </div>
        <div style="display: flex; flex-direction: column">
          <p style="text-align: center">ท่านยินดีรับข้อมูลข่าวสารจากทางบริษัท ต.สยาม คอมเมอร์เชียล จำกัด</p>
        </div>
        <div>
          <mat-radio-group
            id="condition"
            name="condition"
            aria-label="Select an option"
            [formControl]="conditionFormControl"
            style="display: flex; justify-content: center"
          >
            <mat-radio-button value="1">ยินดีรับ</mat-radio-button>
            <!-- "ยินดีรับ" = 1 -->
            <mat-radio-button value="0">ไม่ยอมรับ</mat-radio-button>
            <!-- "ไม่ยอมรับ" = 0 -->
          </mat-radio-group>
        </div>
        <p style="color: red; font-size: 0.8rem">{{ messageError }}</p>

        <div class="btn-submit">
          <button type="button" (click)="onSubmit()" mat-flat-button>SUBMIT</button>
        </div>
      </fieldset>
    </form>
  </div>
</div>
